export { default } from "./SegmentedControl";
